import { render, staticRenderFns } from "./right-customer-detail.vue?vue&type=template&id=ba5bd5f8&scoped=true&"
import script from "./right-customer-detail.vue?vue&type=script&lang=js&"
export * from "./right-customer-detail.vue?vue&type=script&lang=js&"
import style0 from "./right-customer-detail.vue?vue&type=style&index=0&id=ba5bd5f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5bd5f8",
  null
  
)

export default component.exports